import React from "react";

import { Image, Box } from "src/components/base";

const HighlightedPhoto = ({ image, ...props }) => (
  <Box
    flex={1}
    style={{ zIndex: 1 }}
    py={[0, 0, 2]}
    ml={[0, -3, -4, -6]}
    {...props}
  >
    {image && (
      <Image
        sizes={image.sizes}
        fadeIn={true}
        borderRadius={4}
        style={{
          maxHeight: 500,
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
        }}
        boxShadow={2}
        alt={image.description || image.title}
      />
    )}
  </Box>
);

export default HighlightedPhoto;

export const highlightedPhotoFragment = graphql`
  fragment HighlightedPhoto on ContentfulAsset {
    title
    description
    sizes(maxWidth: 1000, quality: 80) {
      ...GatsbyContentfulSizes_withWebp
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/HighlightedPhoto.js